import React from 'react';
import PropTypes from 'prop-types';

const WorkExperienceBox = ({
  title, role, year, theater, stageDirector, conductor, removeItem, editItem,
}) => (
  <li className="work-experience__item" key={`${title}${year}${role}`}>
    <div className="work-experience__description">
      {title}
    </div>
    {
      year && (
      <div className="work-experience__year-theater">
        <span className="work-experience__to-value">Año/Year: {year}</span>
      </div>
      )
    }
    {
      role && (
      <div className="work-experience__year-theater">
        <span className="work-experience__to-value">Rol/Role: {role}</span>
      </div>
      )
    }
    {
      theater && (
      <div className="work-experience__year-theater">
        <span className="work-experience__to-value">Teatro/Theater: {theater}</span>
      </div>
      )
    }
    {stageDirector && conductor && (
      <div className="work-experience__year-theater">
        <span className="work-experience__to-value">Regisseur: {stageDirector}<br />Dir. Musical: {conductor}</span>
      </div>
    )}
    {removeItem && (
      <button
        className="work-experience__item-remove"
        onClick={(e) => {
          e.preventDefault();
          removeItem();
        }}
      >
        <i className="fa fa-times" />
      </button>
    )}
    {editItem && (
      <button
        className="work-experience__item-edit"
        onClick={(e) => {
          e.preventDefault();
          editItem();
        }}
      >
        <i className="fa fa-pencil" />
      </button>
    )}
  </li>
);

WorkExperienceBox.propTypes = {
  title: PropTypes.string.isRequired,
  year: PropTypes.number,
  role: PropTypes.string,
  stageDirector: PropTypes.string,
  conductor: PropTypes.string,
  theater: PropTypes.string,
  removeItem: PropTypes.func,
  editItem: PropTypes.func,
};

WorkExperienceBox.defaultProps = {
  year: undefined,
  role: undefined,
  stageDirector: undefined,
  conductor: undefined,
  theater: undefined,
  removeItem: undefined,
  editItem: undefined,
};

export default WorkExperienceBox;



// WEBPACK FOOTER //
// ./src/components/WorkExperience/Box.js